import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ShareholderActivationResponse } from '../../models/digital-registry/shareholder-activation-response.model';

@Injectable({
  providedIn: 'root',
})
export class ShareholderActivationService {
  private route = environment.apiServer + 'api/v1/shareholder';

  constructor(private http: HttpClient) {}

  activate(token: string): Observable<ShareholderActivationResponse> {
    // noToken: this is an anonymous, [AllowAnonymous] backend endpoint — a visitor
    // clicking the email link has no stored session, so HttpResponseInterceptor must
    // not try to attach/refresh an access token before this request goes out.
    const params = new HttpParams({ fromObject: { noToken: 'noToken', token } });

    return this.http.get<ShareholderActivationResponse>(this.route + '/activate', { params });
  }
}
